// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5u0s9","fullView":"styles_fullView__1vj8Y"};